import React, { useEffect } from 'react';
import CustomDialog from 'components/CustomDialog';
import { setWelcomeVisit } from 'store/slices/sessionStatus';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button, Typography } from '@mui/material';
import FpvCrew from 'images/fpv-crew.png';
import PlaceMagnifier from 'images/place-magnifier.png';
import PlaceStarred from 'images/place-starred.png';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { HelpOptions, setActiveTutorial } from 'store/slices/help';
import { useHistory } from 'react-router-dom';

export const Welcome = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const xsSize = '150px';
    const smSize = '180px';
    useEffect(() => {
        setWelcomeVisit();
    }, []);

    return (
        <CustomDialog
            title={'Welcome to KwadHub!'}
            closeCopy={'Go to the map'}
        >
            <>
                <Button
                    size={'small'}
                    variant='contained'
                    onClick={() => {
                        dispatch(setActiveTutorial(HelpOptions.EXPLORE));
                        history.push('/');
                    }}
                    sx={{
                        'mb': 3,
                        'pt': 2,
                        'pb': 2,
                        'backgroundColor': 'white',
                        'border': '2px solid #ccc',
                        'boxShadow': 'none',
                        'transition': 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
                        'fontFamily': 'inherit',
                        'fontSize': 'inherit',
                        'fontWeight': 'inherit',
                        'color': 'inherit',
                        'textShadow': 'none',
                        '&:hover': {
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                            transform: 'scale(1.02)',
                            backgroundColor: 'white',
                        }
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid
                            xs={5}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box sx={{
                                textAlign: 'center'
                            }}
                            >
                                <Box
                                    component='img'
                                    src={PlaceMagnifier}
                                    alt={'Explore places'}
                                    sx={{
                                        maxHeight: {
                                            xs: xsSize,
                                            sm: smSize
                                        },
                                        maxWidth: {
                                            xs: xsSize,
                                            sm: smSize
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid
                            xs={7}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box>
                                <Box mb={2}>
                                    <Typography
                                        variant={'body1'}
                                        textAlign={'center'}
                                        sx={{
                                            fontSize: '1.4rem',
                                        }}
                                    >
                                        Explore Nearby Spots
                                    </Typography>
                                </Box>
                                <Box ml={1}>
                                    <Typography variant={'body1'} textAlign={'center'}>
                                        Discover hidden flying spots near you! Easily browse a map filled with
                                        recommendations
                                        from fellow drone pilots. Find the perfect spot to take off today!
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Button>

                <Button
                    size={'small'}
                    variant='contained'
                    onClick={() => {
                        dispatch(setActiveTutorial(HelpOptions.SAVE_SPOTS));
                        history.push('/');
                    }}
                    sx={{
                        'mb': 3,
                        'pt': 2,
                        'pb': 2,
                        'backgroundColor': 'white',
                        'border': '2px solid #ccc',
                        'boxShadow': 'none',
                        'transition': 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
                        'fontFamily': 'inherit',
                        'fontSize': 'inherit',
                        'fontWeight': 'inherit',
                        'color': 'inherit',
                        'textShadow': 'none',
                        '&:hover': {
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                            transform: 'scale(1.02)',
                            backgroundColor: 'white',
                        }
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid
                            xs={7}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box>
                                <Box mb={2}>
                                    <Typography
                                        variant={'body1'}
                                        textAlign={'center'}
                                        sx={{
                                            fontSize: '1.4rem',
                                        }}
                                    >
                                        Save Your Favorite Spots
                                    </Typography>
                                </Box>
                                <Box ml={1}>
                                    <Typography variant={'body1'} textAlign={'center'}>
                                        Create your personal collection of drone spots! Pin your favorite places,
                                        organize
                                        them in your account, and choose to keep them private or share with the
                                        community.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid
                            xs={5}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box sx={{
                                textAlign: 'center'
                            }}
                            >
                                <Box
                                    component='img'
                                    src={PlaceStarred}
                                    alt={'Save favourite place'}
                                    sx={{
                                        maxHeight: {
                                            xs: xsSize,
                                            sm: smSize
                                        },
                                        maxWidth: {
                                            xs: xsSize,
                                            sm: smSize
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Button>

                <Button
                    size={'small'}
                    variant='contained'
                    onClick={() => {
                        dispatch(setActiveTutorial(HelpOptions.GROW_NETWORK));
                        history.push('/');
                    }}
                    sx={{
                        'mb': 3,
                        'pt': 2,
                        'pb': 2,
                        'backgroundColor': 'white',
                        'border': '2px solid #ccc',
                        'boxShadow': 'none',
                        'transition': 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
                        'fontFamily': 'inherit',
                        'fontSize': 'inherit',
                        'fontWeight': 'inherit',
                        'color': 'inherit',
                        'textShadow': 'none',
                        '&:hover': {
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                            transform: 'scale(1.02)',
                            backgroundColor: 'white',
                        }
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid
                            xs={5}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box sx={{
                                textAlign: 'center'
                            }}
                            >
                                <Box
                                    component='img'
                                    src={FpvCrew}
                                    alt={'FPV Crew'}
                                    sx={{
                                        maxHeight: {
                                            xs: xsSize,
                                            sm: smSize
                                        },
                                        maxWidth: {
                                            xs: xsSize,
                                            sm: smSize
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid
                            xs={7}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box>
                                <Box mb={2}>
                                    <Typography
                                        variant={'body1'}
                                        textAlign={'center'}
                                        sx={{
                                            fontSize: '1.4rem',
                                        }}
                                    >
                                        Grow Your Drone Network
                                    </Typography>
                                </Box>
                                <Box ml={1}>
                                    <Typography variant={'body1'} textAlign={'center'}>
                                        Join a community of drone enthusiasts! Connect with fellow pilots, share your
                                        favorite spots, and promote your social media profiles to grow your network.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Button>
            </>
        </CustomDialog>
    );
};
